import * as React from "react";
const SvgFiRrSoup = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-soup_svg__a)">
      <path
        fill="#062147"
        d="M13.86 24H10.14c-2.34.01-4.592-.9-6.268-2.534A14.76 14.76 0 0 1 .164 15.15 4.01 4.01 0 0 1 4 10h16a4.01 4.01 0 0 1 3.838 5.15 14.74 14.74 0 0 1-3.708 6.316A8.92 8.92 0 0 1 13.86 24M4 12a1.98 1.98 0 0 0-1.6.8 2.02 2.02 0 0 0-.322 1.791 12.93 12.93 0 0 0 3.2 5.46A6.9 6.9 0 0 0 10.138 22h3.723a6.9 6.9 0 0 0 4.856-1.951 12.9 12.9 0 0 0 3.2-5.46 2.02 2.02 0 0 0-1.025-2.38A2 2 0 0 0 20 12zm12-6a4.38 4.38 0 0 0-1.293-3.121A2.4 2.4 0 0 1 14 1.168V1a1 1 0 0 0-2 0v.168a4.38 4.38 0 0 0 1.293 3.122A2.4 2.4 0 0 1 14 6a1 1 0 0 0 2 0m-4 1v-.308a4.39 4.39 0 0 0-1.292-3.121A2.4 2.4 0 0 1 10 1.864V1a1 1 0 1 0-2 0v.864a4.39 4.39 0 0 0 1.293 3.121A2.4 2.4 0 0 1 10 6.692V7a1 1 0 0 0 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-soup_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSoup;
